// `URL.canParse` is a static method standardized in Chromium 120 / Safari 17 /
// Node 18.17. `@aws-amplify/api-rest`'s `resolveApiUrl` calls it for every REST
// request, and when the host runtime lacks it the call throws — which the
// resolver catches and rethrows as the misleading "API name is invalid." error,
// so every REST request fails. Older web runtimes (legacy browsers, some
// embedded WebViews, and the Electron build Cypress bundles) hit this. Define a
// spec-compatible fallback when the runtime does not provide one.
type CanParse = (url: string | URL, base?: string | URL) => boolean;

if (typeof (URL as unknown as { canParse?: CanParse }).canParse !== 'function') {
    (URL as unknown as { canParse: CanParse }).canParse = (url, base) => {
        try {
            // eslint-disable-next-line no-new
            new URL(url, base);
            return true;
        } catch {
            return false;
        }
    };
}
